import React from 'react';
import { useSelector } from 'react-redux';
import { ClientName, RequestBudgetStatus } from '../../model/constants';

const PromotionStatusPopup = () => {
    const { settings } = useSelector(state => state.configurator);

    const getStatusMessage = () => {
        const name = settings?.name;
        const requestBudgetStatus = settings?.request_budget_status;

        switch (requestBudgetStatus) {
            case RequestBudgetStatus.RequestBudgetEnded:
                // eslint-disable-next-line max-len
                return `El proceso de formalización para la promoción ${name} ha finalizado. / The customization process for the ${name} promotion has finished.`;

            default:
                // eslint-disable-next-line max-len
                return `La herramienta de personalización para la promoción ${name} está inactiva. / The customization tool for the ${name} promotion is inactive.`;
        }
    };

    return (
      <div className="promotion-status-popup">
        <div className="background opened" />
        <div className="panel opened">
          <div className="header">Configurador de {ClientName} / {ClientName} configurator</div>
          <div className="subheader">{getStatusMessage()}</div>
        </div>
      </div>
    );
};

export default PromotionStatusPopup;
